import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withKeys as _withKeys, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "creationV2__scroll-wrapper" }
const _hoisted_2 = { class: "creationV2__container" }
const _hoisted_3 = {
  key: 0,
  class: "flex items-center gap-2 lg:gap-[calc(8px+0.1vw)] creation__text-small text-creation-on-background"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "text-creation-on-background/creation-medium" }, "You rated", -1)
const _hoisted_5 = { class: "inline-flex border border-creation-on-background rounded-md lg:rounded-[calc(6px+0.025vw)] px-2 py-0.5 lg:px-[calc(8px+0.05vw)] lg:py-[calc(2px+0.1vw)] creation__text-xsmall" }
const _hoisted_6 = {
  key: 0,
  class: "flex items-center gap-2 lg:gap-[calc(8px+0.3vw)]"
}
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { class: "relative flex justify-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/icons-v3.svg#star-custom" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "creation__text-small text-creation-on-background/creation-medium font-semibold" }
const _hoisted_12 = { class: "font-normal" }
const _hoisted_13 = {
  key: 0,
  class: "font-bold text-2xl xs:text-3xl lg:text-[3vw] lg:leading-tight text-creation-on-background"
}
const _hoisted_14 = {
  key: 1,
  class: "flex flex-col gap-4 lg:gap-[calc(16px+0.2vw)]"
}
const _hoisted_15 = { class: "font-bold text-2xl xs:text-3xl lg:text-[3vw] lg:leading-tight text-creation-on-background" }
const _hoisted_16 = ["contenteditable"]
const _hoisted_17 = {
  key: 0,
  class: "absolute inset-x-0 bottom-12 flex justify-center w-full p-4 lg:p-8"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "inline-flex items-center justify-center w-20 h-20 xs:w-24 xs:h-24" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "w-12 h-12 text-black relative z-10 animate-spin",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("defs", null, [
      /*#__PURE__*/_createElementVNode("linearGradient", { id: "spinner-secondHalf" }, [
        /*#__PURE__*/_createElementVNode("stop", {
          offset: "0%",
          "stop-opacity": "0",
          "stop-color": "currentColor"
        }),
        /*#__PURE__*/_createElementVNode("stop", {
          offset: "100%",
          "stop-opacity": "0.5",
          "stop-color": "currentColor"
        })
      ]),
      /*#__PURE__*/_createElementVNode("linearGradient", { id: "spinner-firstHalf" }, [
        /*#__PURE__*/_createElementVNode("stop", {
          offset: "0%",
          "stop-opacity": "1",
          "stop-color": "currentColor"
        }),
        /*#__PURE__*/_createElementVNode("stop", {
          offset: "100%",
          "stop-opacity": "0.5",
          "stop-color": "currentColor"
        })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("g", { "stroke-width": "5" }, [
      /*#__PURE__*/_createElementVNode("path", {
        stroke: "url(#spinner-secondHalf)",
        d: "M 8 24 A 16 16 0 0 1 40 24"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        stroke: "url(#spinner-firstHalf)",
        d: "M 40 24 A 16 16 0 0 1 8 24"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        d: " M 8 25 A 20 20 0 0 1 8 24"
      })
    ])
  ])
], -1)
const _hoisted_19 = { class: "absolute inset-x-0 bottom-12 flex justify-between items-end w-full p-4 lg:p-8" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "button button--circle-creation invisible" }, null, -1)
const _hoisted_21 = {
  key: 0,
  class: "textblink-animation absolute text-center -top-9 text-creation-on-background/creation-high"
}
const _hoisted_22 = {
  class: "record-button__wrapper",
  id: "prompt-start-recording-button"
}
const _hoisted_23 = {
  key: 0,
  class: "icon w-10 h-10 stroke-1 text-black absolute z-10"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/icons-v3.svg#mic-filled" }, null, -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = {
  key: 1,
  class: "icon w-10 h-10 text-black absolute z-10"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/icons-v3.svg#stop" }, null, -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = {
  key: 0,
  class: "w-12 h-12 text-black relative z-10 animate-spin",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48",
  fill: "none"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("linearGradient", { id: "spinner-secondHalf" }, [
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "0%",
      "stop-opacity": "0",
      "stop-color": "currentColor"
    }),
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "100%",
      "stop-opacity": "0.5",
      "stop-color": "currentColor"
    })
  ]),
  /*#__PURE__*/_createElementVNode("linearGradient", { id: "spinner-firstHalf" }, [
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "0%",
      "stop-opacity": "1",
      "stop-color": "currentColor"
    }),
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "100%",
      "stop-opacity": "0.5",
      "stop-color": "currentColor"
    })
  ])
], -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("g", { "stroke-width": "5" }, [
  /*#__PURE__*/_createElementVNode("path", {
    stroke: "url(#spinner-secondHalf)",
    d: "M 8 24 A 16 16 0 0 1 40 24"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    stroke: "url(#spinner-firstHalf)",
    d: "M 40 24 A 16 16 0 0 1 8 24"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    stroke: "currentColor",
    "stroke-linecap": "round",
    d: " M 8 25 A 20 20 0 0 1 8 24"
  })
], -1)
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "record-button__circle" }, null, -1)
const _hoisted_34 = {
  key: 0,
  class: "record-button__morphing"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_37 = [
  _hoisted_35,
  _hoisted_36
]
const _hoisted_38 = ["fill"]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "circle",
    d: "\n                                                M 50, 50\n                                                m -37, 0\n                                                a 37,37 0 1,1 74,0\n                                                a 37,37 0 1,1 -74,0"
  })
], -1)
const _hoisted_40 = { fill: "currentColor" }
const _hoisted_41 = {
  key: 0,
  "xlink:href": "#circle"
}
const _hoisted_42 = { class: "relative inline-flex" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("svg", { class: "button__icon" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/icons-v3.svg#keyboard" })
], -1)
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = /*#__PURE__*/_createElementVNode("svg", { class: "button__icon" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/icons-v3.svg#mic-filled" })
], -1)
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = /*#__PURE__*/_createElementVNode("svg", { class: "button__icon stroke-2" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/icons-v3.svg#arrow-right" })
], -1)
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "button button--circle-creation invisible" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["creationV2__body", { 'creationV2__body--keyboard': _ctx.isTextSurvey, 'creationV2__body--record': !_ctx.isTextSurvey }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_Transition, {
          name: "custom-classes",
          "enter-active-class": "animate__fadeInUp",
          "leave-active-class": "animate__fadeOut"
        }, {
          default: _withCtx(() => [
            (_ctx.showNPSRating)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _hoisted_4,
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("span", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.rating), 1),
                      _createTextVNode(" / 10")
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_Transition, {
          name: "custom-classes",
          "enter-active-class": "animate__fadeInUp",
          "leave-active-class": "animate__fadeOut"
        }, {
          default: _withCtx(() => [
            (_ctx.showCSATRating)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2, 3, 4, 5], (i) => {
                      return _createElementVNode("div", {
                        key: i,
                        class: "cursor-pointer select-none"
                      }, [
                        _createElementVNode("div", _hoisted_8, [
                          (_openBlock(), _createElementBlock("svg", {
                            class: _normalizeClass(["icon w-5 h-5 lg:w-[calc(20px+1.2vw)] lg:h-[calc(20px+1.2vw)] transition group-hover:scale-110", { 'text-creation-on-background': this.isCSATStarSelected(i), 'text-creation-on-background/creation-low': !this.isCSATStarSelected(i) }])
                          }, _hoisted_10, 2))
                        ])
                      ])
                    }), 64))
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createTextVNode(_toDisplayString(_ctx.getRatingTitle) + " ", 1),
                    _createElementVNode("span", _hoisted_12, "(" + _toDisplayString(_ctx.rating) + ")", 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_Transition, {
          mode: "out-in",
          name: "custom-classes",
          "enter-active-class": "animate__fadeInUp",
          "leave-active-class": "animate__fadeOut"
        }, {
          default: _withCtx(() => [
            (_ctx.isShowingFollowUpQuestionInfo && !_ctx.isUsersTurn && !_ctx.didShowLoaderMessage)
              ? (_openBlock(), _createElementBlock("h1", _hoisted_13, _toDisplayString(_ctx.loaderMessage), 1))
              : (!!_ctx.agentMessage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("h1", _hoisted_15, _toDisplayString(_ctx.agentMessage), 1),
                    (_ctx.showTextField)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          ref: "answerText",
                          contenteditable: !_ctx.showLoader ? 'plaintext-only' : false,
                          onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args))),
                          onKeydown: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onEnterPressed && _ctx.onEnterPressed(...args)), ["enter"])),
                          style: _normalizeStyle(`--keyboardInputText: '${_ctx.$t('creation.textAreaKeyboardPlaceholder')}'`),
                          class: _normalizeClass([{ 'before:hidden': !_ctx.showTextPlaceholder, 'opacity-40': _ctx.showLoader }, "keyboard-input font-medium w-full py-2 lg:py-[0.8vw] transition text-lg lg:text-[2.5vw] leading-tight text-creation-on-background focus:ring-0 focus:outline-none before:text-creation-on-background/creation-low"])
                        }, null, 46, _hoisted_16))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ]),
    (_ctx.showLoader)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createVNode(_Transition, {
            appear: "",
            name: "custom-classes",
            "enter-active-class": "animate__fadeInUp",
            "leave-active-class": "animate__fadeOutDown"
          }, {
            default: _withCtx(() => [
              _hoisted_18
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_19, [
      _hoisted_20,
      _createVNode(_Transition, {
        name: "custom-classes",
        "enter-active-class": "animate__fadeInUp",
        "leave-active-class": "animate__fadeOutDown"
      }, {
        default: _withCtx(() => [
          (_ctx.showMicrophoneState)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: _normalizeClass(["record-button", { 'record-button--recording': _ctx.isRecordingInProgress }]),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.recordingButtonTapped()))
              }, [
                (_ctx.isRecordingInProgress)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.$t('survey.talkLabel')), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_Transition, {
                    name: "custom-classes",
                    "enter-active-class": "animate__zoomIn",
                    "leave-active-class": "animate__zoomOut"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.isRecordingReady)
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_23, _hoisted_25))
                        : (_ctx.isRecordingInProgress)
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_26, _hoisted_28))
                          : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  (_ctx.isRecorderLoading)
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_29, _hoisted_32))
                    : _createCommentVNode("", true),
                  _createVNode(_Transition, {
                    name: "custom-classes",
                    "enter-active-class": "animate__fadeIn",
                    "leave-active-class": "animate__fadeOut"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_33
                    ]),
                    _: 1
                  }),
                  _createVNode(_Transition, {
                    name: "custom-classes",
                    "enter-active-class": "animate__fadeIn",
                    "leave-active-class": "animate__fadeOut"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.isRecordingInProgress)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, _hoisted_37))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                (!_ctx.isRecorderLoading && !_ctx.isRecordingInProgress)
                  ? (_openBlock(), _createElementBlock("svg", {
                      key: 1,
                      class: "record-button__circle-path",
                      id: "record-button",
                      viewBox: "0 0 100 100",
                      fill: _ctx.campaignBrandingManager.shouldShowBackgroundImageFor(_ctx.campaign) ? 'white' : ''
                    }, [
                      _hoisted_39,
                      _createElementVNode("text", _hoisted_40, [
                        (!_ctx.isRecorderLoading)
                          ? (_openBlock(), _createElementBlock("textPath", _hoisted_41, _toDisplayString(_ctx.isRecordingInProgress ? "" : _ctx.campaign.recordButtonLabel || _ctx.$t('survey.startRecordingButtonLabel')), 1))
                          : _createCommentVNode("", true)
                      ])
                    ], 8, _hoisted_38))
                  : _createCommentVNode("", true)
              ], 2))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_42, [
        _createVNode(_Transition, {
          name: "custom-classes",
          "enter-active-class": "animate__fadeInUp",
          "leave-active-class": "animate__fadeOutDown"
        }, {
          default: _withCtx(() => [
            (_ctx.showTextEnableButton)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "button button--circle-creation button--circle-creation-primary absolute z-20",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.switchAnswerStateToText && _ctx.switchAnswerStateToText(...args)))
                }, _hoisted_44))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_Transition, {
          name: "custom-classes",
          "enter-active-class": "animate__fadeInUp",
          "leave-active-class": "animate__fadeOutDown"
        }, {
          default: _withCtx(() => [
            (_ctx.showAudioEnableButton)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "button button--circle-creation button--circle-creation-primary absolute z-20",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.switchAnswerStateToAudio && _ctx.switchAnswerStateToAudio(...args)))
                }, _hoisted_46))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_Transition, {
          name: "custom-classes",
          "enter-active-class": "animate__fadeInUp",
          "leave-active-class": "animate__fadeOutDown"
        }, {
          default: _withCtx(() => [
            (_ctx.showTextSendButton)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "button button--circle-creation button--circle-creation-primary absolute z-20",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.sendTextMessage && _ctx.sendTextMessage(...args)))
                }, _hoisted_48))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _hoisted_49
      ])
    ])
  ], 2))
}